import styled from "@emotion/styled";
import { Button, Card } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export const PendingCampaignsPageWrapper = styled.div(() => ({}));

export const PendingCampaignsHeaderItem = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	color: theme.project.colors.fontColors.main,
	minHeight: "56px",
	h3: {
		margin: 0,
		fontWeight: 500,
		fontSize: 48,
		lineHeight: 1.2,
		wordBreak: "break-word"
	}
}));

export const CampaignItemWrapper = styled(Card)(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	minHeight: "120px",
	color: theme.project.colors.fontColors.main,
	padding: "0 32px",
	borderRadius: "unset",
	display: "grid",
	alignItems: "center",
	columnGap: "10px",
	gridTemplateColumns: "42px minmax(0, 4fr) minmax(90px, 1fr) minmax(120px, 1fr) 24px",
	cursor: "pointer",
	"&:focus-visible": {
		outline: `2px solid ${theme.project.colors.primaryColors.main}`,
		outlineOffset: "2px"
	},
	"& > div": {
		minWidth: 0
	},
	"& > div:first-of-type": {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center"
	},
	"& > div:not(:first-of-type)": {
		justifySelf: "start"
	},
	"& p": {
		margin: 0
	},
	[theme.breakpoints.down("sm")]: {
		padding: "12px 8px",
		gridTemplateColumns: "38px minmax(0, 1fr) 24px",
		"& > div:nth-of-type(n+2)": { gridColumn: "2", display: "flex", gap: "8px" }
	}
}));

export const CampaignItemChevron = styled(ChevronRightIcon)({
	justifySelf: "end"
});

export const PendingCampaignsContainer = styled.div({
	margin: "16px",
	backgroundColor: "#f7f7f7",
	display: "flex",
	flexDirection: "column",
	gap: "16px"
});

export const ShipSelectedButton = styled(Button)(({ theme }) => ({
	alignSelf: "flex-start",
	width: "fit-content",
	backgroundColor: "transparent",
	border: `1px solid ${theme.project.colors.primaryColors.main}`,
	color: theme.project.colors.primaryColors.main,
	"&:hover": {
		backgroundColor: "transparent",
		borderColor: theme.project.colors.primaryColors.main,
		color: theme.project.colors.primaryColors.main
	},
	"&.Mui-disabled": {
		borderColor: theme.palette.action.disabled,
		color: theme.palette.action.disabled,
		backgroundColor: "transparent"
	}
}));
